import { messageActionTypes } from './message.types';

const INITIAL_STATE = {
    messages: []
};

const messageReducer = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case messageActionTypes.SET_NEW_MESSAGE:
            return {
                ...state,
                messages: state.messages.push(action.payload)
            };
        default:
            return state;
    }
};

export default messageReducer;